export default __webpack_public_path__ + "static/media/manage-school-white.24e81a92.svg";